<script>
    import {Bar, mixins} from 'vue-chartjs'

    const {reactiveProp} = mixins;

    export default {
        name: 'BarChart',
        extends: Bar,
        mixins: [reactiveProp],
        props: ['options'],
        mounted() {
            this.renderChart(this.chartData, {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                        }
                    }],
                }, ...this.options
            })
        }
    }
</script>

<style>
</style>